import { useEffect, useState } from "react";
import ModalForgotPassword from "../../components/Layout/ModalForgotPassword";
import { useTokenContext } from "../../context/tokenContext";
import { NavLink, useNavigate } from "react-router-dom";
import {
  login,
  logWithOffice,
} from "../../services/Api/loginService";
import Cookies from "js-cookie";
import Eye from "../../assets/icons/eye.svg";
import { redirection } from "../../services/Utils/functionService";
import Modal2fa from "../../components/Layout/Modal2fa";
import { useConnexionStore } from "../../stores/Layout/connexion";
import { initSocket } from "../../services/Utils/socketIo";
import { getNotifications } from "../../services/Api/userService";
import { useNotifsStore } from "../../stores/Utils/notifs";
import logo from "../../assets/logos/logoX.png";
import microsoft from "../../assets/logos/microsoft.png";
import user from "../../assets/icons/user.svg";
import { ToastContainer } from "react-toastify";
import VerifyEmailRegister from "../../components/Layout/VerifyEmailRegister";
import { showToastError } from "../../services/Toasts/toasts";
import { useMsal } from "@azure/msal-react";
import GoogleLoginButton from "../../components/Layout/GoogleLoginButton";

const Connexion = () => {
  // Store
  const {
    setDisplayPopUpCookie,
    email,
    setEmail,
    password,
    setPassword,
    setShowModalForgotPassword,
    passwordInputType,
    setPasswordInputType,
    setShowModal2fa,
    setShowModalVerifyEmail,
  } = useConnexionStore();
  const [isLoading, setIsLoading] = useState(false);

  const { setNotifs } = useNotifsStore();

  //Context
  const { refreshUserData } = useTokenContext();

  // Context
  const {
    setFirstname,
    setUtc,
    setUtp,
    setIsAdmin,
    setIsSuperAdmin,
  } = useTokenContext();

  // Hooks
  const navigate = useNavigate();

  // Cookie
  const consentementCookies = Cookies.get("consentementCookies");

  // Function to toggle password visibility
  const togglePasswordVisibility = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setPasswordInputType(
      passwordInputType === "password" ? "text" : "password"
    );
  };

  // Display pop up cookie
  useEffect(() => {
    if (!consentementCookies) {
      setDisplayPopUpCookie(true);
    } else {
      setDisplayPopUpCookie(false);
    }
  }, [consentementCookies]);

  // function for login
  const handleLogin = async () => {
    setIsLoading(true);

    try {
      const response = await login(email, password);
      
      // Socket
      if (response?.data?.id) {
        // Attendre que refreshUserData soit terminé avant de rediriger
        await refreshUserData();
        
        redirection(location, navigate, Number(response?.data?.isSuperAdmin));
        initSocket(response?.data?.id);
        setEmail("");
        setPassword("");
        setIsLoading(false);
        // Get notifications
        getNotifications()
          .then((response) => setNotifs(response))
          .catch(() => showToastError("Une erreur s'est produite"));
        }

    } catch (error: any) {
      setIsLoading(false);
      if (error.message) {
        setUtc(0);
        setUtp(0);
        setIsAdmin(0);
        setIsSuperAdmin(0);
        setFirstname("");
      }
      if (
        error.message &&
        typeof error.message === "string" &&
        error.message.trim() === "eMail 2FA sent"
      ) {
        setShowModal2fa(true);
      } else if (
        error.message &&
        typeof error.message === "string" &&
        error.message.trim() === "Mot de passe incorrect"
      ) {
        showToastError("Mot de passe incorrect");
      } else if (
        error.message &&
        typeof error.message === "string" &&
        error.message.trim() === "googleAccount"
      ) {
        showToastError("Merci de vous connecter avec Google.");
      } else if (
        error.message &&
        typeof error.message === "string" &&
        error.message.trim() === "officeAccount"
      ) {
        showToastError("Merci de vous connecter avec Office.");
      } else if (
        error.message &&
        typeof error.message === "string" &&
        error.message.trim() === "accountNotCreated"
      ) {
        showToastError("Merci de créer votre compte avant de vous connecter.");
      }
    }
  };

  const { instance } = useMsal();

  // Login with office
  const handleLoginOffice = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      const msalResponse = await instance.loginPopup({
        scopes: ["user.read"],
      });
      
      const response = await logWithOffice(msalResponse.idToken, msalResponse.accessToken);
      // Attendre que refreshUserData soit terminé avant de rediriger
      await refreshUserData();
      initSocket(response?.data?.id);
      redirection(location, navigate, response?.data?.isSuperAdmin);
    } catch (error: any) {
      if (
        error.message &&
        typeof error.message === "string" &&
        error.message.trim() === "User not invited"
      ) {
        setUtc(0);
        setUtp(0);
        setIsAdmin(0);
        setIsSuperAdmin(0);
        setFirstname("");
        showToastError("Vous n'avez pas été invité a rejoindre Nexum.");
      } else if (
        error.message &&
        typeof error.message === "string" &&
        error.message.trim() === "User exist but account not linked"
      ) {
        showToastError(
          "Vous devez lier votre compte office à votre compte Nexum."
        );
      } else {
        // Log temporaire pour diagnostiquer l'erreur réelle (MSAL, backend, etc.)
        console.error("Erreur connexion Office :", error);
        showToastError("Une erreur est survenue lors de la connexion.");
      }
    }
  };

  return (
    <div className="relative min-h-dvh w-full overflow-x-hidden overflow-y-auto">
      <ToastContainer position="top-center" />
      
      {/* Background gradient */}
      <div className="fixed inset-0 bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100"></div>
      
      {/* Logo */}
      <div className="absolute left-6 top-5 z-30 hidden transition-transform duration-300 hover:scale-110 md:block lg:left-8 lg:top-6">
        <img src={logo} alt="logo Nexum" className="w-12 h-16 drop-shadow-lg" />
      </div>
      
      {/* Main container */}
      <main className="relative z-20 flex min-h-dvh w-full items-start justify-center sm:items-center sm:px-6 sm:py-8 lg:px-10">
        <form 
          onSubmit={(e) => {
            e.preventDefault();
            handleLogin();
          }} 
          className="relative z-20 flex min-h-[100dvh] w-full max-w-md flex-col items-center overflow-hidden bg-white/95 px-5 py-5 backdrop-blur-sm sm:min-h-0 sm:rounded-2xl sm:border sm:border-white/20 sm:px-8 sm:py-7 sm:shadow-2xl sm:transition-all sm:duration-500 sm:hover:shadow-3xl lg:max-w-lg"
        >
          {/* Decorative elements */}
          <div className="absolute -left-10 -top-10 z-10 hidden h-20 w-20 rotate-12 rounded-2xl border-2 border-dark-lavender bg-gradient-to-br from-light-lavender to-dark-lavender2 shadow-2xl transition-transform duration-300 sm:block"></div>
          
          {/* Header */}
          <div className="pb-5 pt-2 text-center sm:pb-6 sm:pt-3">
            <img src={logo} alt="Nexum" className="mx-auto mb-3 h-12 w-auto drop-shadow-md md:hidden" />
            <h1 className="mb-2 font-K2D text-2xl font-bold tracking-wide text-gray-700 sm:text-3xl 3xl:text-4xl">
              SE CONNECTER
            </h1>
            <div className="w-16 h-1 bg-gradient-to-r from-yellow-trio to-yellow-400 rounded-full mx-auto"></div>
          </div>
          
          {/* Email field */}
          <div className="w-full max-w-sm space-y-1.5 sm:space-y-2">
            <label
              htmlFor="email"
              className="text-gray-700 text-sm 3xl:text-lg font-BarlowCondensed font-medium block"
            >
              Identifiant
            </label>
            <div className="relative group">
              <input
                 type="email"
                 className="form-input-modern h-11 w-full rounded-xl border-2 border-gray-200 bg-gray-50 px-4 text-base text-gray-700 shadow-sm transition-all duration-300 placeholder:text-gray-400 group-hover:shadow-md focus:border-yellow-trio focus:bg-white focus:outline-none sm:h-12"
                 pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                 onChange={(e) => setEmail(e.target.value)}
                 minLength={10}
                 maxLength={200}
                 value={email}
                 name="email"
                 id="email"
                 placeholder="votre@email.com"
                 required
               />
              <div className="absolute inset-0 rounded-xl transition-all duration-300 group-hover:bg-gradient-to-r group-hover:from-yellow-trio/10 group-hover:to-yellow-400/10 pointer-events-none"></div>
            </div>
          </div>
          
          {/* Password field */}
          <div className="mt-3 w-full max-w-sm space-y-1.5 sm:mt-4 sm:space-y-2">
            <label
              htmlFor="password"
              className="text-gray-700 text-sm 3xl:text-lg font-BarlowCondensed font-medium block"
            >
              Mot de passe
            </label>
            <div className="relative group">
              <input
                 type={passwordInputType}
                 className="form-input-modern h-11 w-full rounded-xl border-2 border-gray-200 bg-gray-50 px-4 pr-12 text-base text-gray-700 shadow-sm transition-all duration-300 placeholder:text-gray-400 group-hover:shadow-md focus:border-yellow-trio focus:bg-white focus:outline-none sm:h-12"
                 pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                 onChange={(e) => setPassword(e.target.value)}
                 name="password"
                 value={password}
                 id="password"
                 placeholder="••••••••"
                 required
               />
              <button
                type="button"
                className="absolute right-3 top-1/2 transform -translate-y-1/2 p-1 rounded-lg hover:bg-gray-100 transition-colors duration-200"
                onClick={(e) => togglePasswordVisibility(e)}
              >
                <img src={Eye} alt="oeil" className="w-5 h-5 opacity-60 hover:opacity-100 transition-opacity duration-200" />
              </button>
              <div className="absolute inset-0 rounded-xl transition-all duration-300 group-hover:bg-gradient-to-r group-hover:from-yellow-trio/10 group-hover:to-yellow-400/10 pointer-events-none"></div>
            </div>
          </div>
          
          {/* Forgot password */}
          <button
            type="button"
            className="my-3 min-h-10 cursor-pointer px-2 text-sm font-thin italic text-gray-700 decoration-2 underline-offset-4 transition-colors duration-300 hover:text-dark-lavender hover:decoration-yellow-trio sm:my-4"
            onClick={() => setShowModalForgotPassword(true)}
          >
            Mot de passe oublié ?
          </button>
          <ModalForgotPassword />

          {/* Login button */}
          <button
            type="submit"
            tabIndex={0}
            disabled={isLoading}
            className={`${isLoading ? "cursor-not-allowed opacity-50" : "cursor-pointer opacity-90 hover:opacity-100"} btn-modern h-11 w-full max-w-sm rounded-xl border-0 bg-gradient-to-r from-yellow-trio to-yellow-400 font-BarlowCondensed text-lg font-semibold text-gray-700 shadow-lg transition-all duration-300 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-yellow-trio focus:ring-offset-2 sm:h-12 sm:w-40 sm:hover:scale-105`}
          >
            {isLoading ? "Connexion..." : "Se connecter"} 
          </button>

          {/* Divider */}
          <div className="my-4 flex w-full max-w-sm items-center sm:my-5">
            <div className="flex-1 h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent"></div>
            <span className="px-4 text-gray-500 text-sm font-medium">ou</span>
            <div className="flex-1 h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent"></div>
          </div>

          {/* Social login buttons */}
          <div className="w-full max-w-sm space-y-3 sm:space-y-4">
            {/* Composant GoogleLogin caché pour la fonctionnalité */}
            <GoogleLoginButton />
            <button
              type="button"
              className="group flex h-11 w-full cursor-pointer items-center justify-center gap-2 rounded-xl border-2 border-gray-200 bg-white px-3 text-sm font-medium text-gray-700 shadow-sm transition-all duration-300 hover:border-blue-300 hover:bg-blue-50 hover:shadow-md min-[360px]:text-base sm:h-12 sm:gap-3"
              onClick={(e) => handleLoginOffice(e)}
            >
              <img
                src={microsoft}
                alt="logo microsoft"
                className="h-5 w-5 transition-transform duration-300 group-hover:scale-110"
              />
              <span>Se connecter avec Office</span>
            </button>

            <button
              type="button"
              className="group flex h-11 w-full cursor-pointer items-center justify-center gap-2 rounded-xl border-2 border-gray-200 bg-white px-3 text-sm font-medium text-gray-700 shadow-sm transition-all duration-300 hover:border-green-300 hover:bg-green-50 hover:shadow-md min-[360px]:text-base sm:h-12 sm:gap-3"
              onClick={() => setShowModalVerifyEmail(true)}
            >
              <img src={user} alt="logo user" className="h-5 w-5 transition-transform duration-300 group-hover:scale-110" />
              <span>Créer un compte</span>
            </button>
          </div>

          <VerifyEmailRegister />
          <Modal2fa />
          
          {/* Footer links */}
          <footer className="mt-auto flex flex-col items-center justify-end pb-1 pt-5 font-BarlowCondensed sm:mt-0 sm:pb-0 sm:pt-6">
            <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-gray-600">
              <NavLink
                to="/legalnotice"
                className="text-sm cursor-pointer hover:text-yellow-trio transition-colors duration-300 underline decoration-1 underline-offset-2"
              >
                Mentions légales
              </NavLink>
              <p> - </p>
              <NavLink
                to="/cookiesnotice"
                className="text-sm cursor-pointer hover:text-yellow-trio transition-colors duration-300 underline decoration-1 underline-offset-2"
              >
                Cookies
              </NavLink>
              <p> - </p>
              <NavLink 
                to="/cgu" 
                className="text-sm cursor-pointer hover:text-yellow-trio transition-colors duration-300 underline decoration-1 underline-offset-2"
              >
                CGU
              </NavLink>
            </div>
            <p className="mt-1 text-center text-xs font-extralight text-gray-500">
              © 2026 by TRIONODE.
            </p>
          </footer>
          
          {/* Decorative element */}
          <div className="absolute -bottom-10 -right-10 z-10 hidden h-20 w-20 -rotate-12 rounded-2xl border-2 border-light-lavender bg-gradient-to-br from-light-lavender to-dark-lavender shadow-2xl transition-transform duration-300 sm:block"></div>
        </form>
      </main>
    </div>
  );
};

export default Connexion;
